import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/__auth/admin/groups")({
    component: GroupsLayout,
});

function GroupsLayout() {
    return <Outlet />;
}
